export const SLOT_DISPLAY_NAMES = {
  head: "Head",
  neck: "Neck",
  shoulder: "Shoulders",
  cape: "Back",
  chest: "Chest",
  shirt: "Shirt",
  tabard: "Tabard",
  wrist: "Wrist",
  gloves: "Gloves",
  belt: "Belt",
  legs: "Legs",
  feet: "Feet",
  ring1: "Ring",
  ring2: "Ring",
  trinket1: "Trinket",
  trinket2: "Trinket",
  weapon1: "Main Hand",
  weapon2: "Off Hand",
};

const BUILD_ITEM_TYPES = ["popularity_item", "dps_item", "hps_item"];

// The pairs payload identifies an embellishment but not the gear it was
// crafted on, so the carriers shown in the UI are resolved from the
// recommended builds: every slot whose build lists this reagent among its
// embellishments, one entry per slot. A doubled pair takes the first two.
export const findEmbellishmentCarriers = (builds, embellishmentItemId) => {
  if (!builds || !embellishmentItemId) return [];

  const carriers = [];
  for (const itemType of BUILD_ITEM_TYPES) {
    for (const [slot, slotBuilds] of Object.entries(builds)) {
      const build = slotBuilds?.[itemType];
      if (
        build?.item_id > 0 &&
        (build.embellishment_item_ids || []).includes(embellishmentItemId) &&
        !carriers.some((carrier) => carrier.slot === slot)
      ) {
        carriers.push({ slot, itemId: build.item_id, quality: build.quality });
      }
    }
  }

  return carriers;
};

export const findSlotForItem = (slotItems, itemId) => {
  if (!slotItems || !itemId) return null;

  for (const [slot, slotData] of Object.entries(slotItems)) {
    if ((slotData?.items || []).some((item) => item.item_id === itemId)) {
      return slot;
    }
  }

  return null;
};
